import enUS from "antd/lib/locale/en_US";
import zhCN from "antd/lib/locale/zh_CN";

export const antdLocalePackage = {
  en: enUS,
  zh_cn: zhCN,
};
